var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystoreButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 52,
    viewBox: "0 0 182 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_2755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.259 52H6.74074C3.03502 52 0 49.0734 0 45.5V6.5C0 2.92663 3.03502 1.90735e-06 6.74074 1.90735e-06H175.259C178.965 1.90735e-06 182 2.92663 182 6.5V45.5C182 49.0734 178.965 52 175.259 52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.259 1.04162C178.38 1.04162 180.92 3.4905 180.92 6.5V45.5C180.92 48.5095 178.38 50.9584 175.259 50.9584H6.74074C3.61978 50.9584 1.0802 48.5095 1.0802 45.5V6.5C1.0802 3.4905 3.61978 1.04162 6.74074 1.04162H175.259ZM175.259 1.90735e-06H6.74074C3.03502 1.90735e-06 0 2.92663 0 6.5V45.5C0 49.0734 3.03502 52 6.74074 52H175.259C178.965 52 182 49.0734 182 45.5V6.5C182 2.92663 178.965 1.90735e-06 175.259 1.90735e-06Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0678 9.80032C13.6718 10.2001 13.4426 10.8224 13.4426 11.6284V40.3779C13.4426 41.1839 13.6718 41.8063 14.0678 42.2061L14.1656 42.2938L30.8725 26.1901V25.8098L14.1656 9.70607L14.0678 9.80032Z",
    fill: "url(#paint0_linear_301_2755)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4354 31.5607L30.8726 26.1901V25.8099L36.4421 20.4392L36.5668 20.5091L43.1626 24.128C45.045 25.155 45.045 26.845 43.1626 27.8785L36.5668 31.4909L36.4354 31.5607Z",
    fill: "url(#paint1_linear_301_2755)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5668 31.4908L30.8725 26L14.0679 42.2061C14.6931 42.8398 15.7126 42.9162 16.872 42.2825L36.5668 31.4908Z",
    fill: "url(#paint2_linear_301_2755)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5668 20.5091L16.872 9.71751C15.7126 9.09026 14.6931 9.16663 14.0679 9.80038L30.8725 26L36.5668 20.5091Z",
    fill: "url(#paint3_linear_301_2755)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9258 13.3169C63.9258 14.4024 63.5888 15.2717 62.9248 15.9201C62.1614 16.6887 61.1671 17.0755 59.9488 17.0755C58.7843 17.0755 57.79 16.6822 56.9744 15.9071C56.1571 15.1206 55.7493 14.1554 55.7493 13C55.7493 11.8446 56.1571 10.8794 56.9744 10.0994C57.79 9.31775 58.7843 8.9245 59.9488 8.9245C60.5285 8.9245 61.0812 9.03987 61.6087 9.25437C62.1344 9.4705 62.5625 9.763 62.8725 10.1237L62.1681 10.8095C61.6272 10.1936 60.8908 9.88975 59.9488 9.88975C59.0994 9.88975 58.363 10.1757 57.7378 10.7526C57.1193 11.3311 56.8092 12.0802 56.8092 13C56.8092 13.9197 57.1193 14.6754 57.7378 15.2539C58.363 15.8242 59.0994 16.1167 59.9488 16.1167C60.8503 16.1167 61.6087 15.8242 62.2069 15.2474C62.6012 14.8655 62.8254 14.339 62.8843 13.6662H59.9488V12.727H63.8651C63.9123 12.9301 63.9258 13.1267 63.9258 13.3169Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1392 10.0604H66.4604V12.5304H69.7768V13.4696H66.4604V15.9396H70.1392V16.8968H65.4189V9.10327H70.1392V10.0604Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.524 16.8968H73.4825V10.0604H71.2261V9.10327H76.7821V10.0604H74.524V16.8968Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.803 16.8968V9.10327H81.8427V16.8968H80.803Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4517 16.8968H85.4187V10.0604H83.1538V9.10327H88.7166V10.0604H86.4517V16.8968Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2356 15.8941C98.4385 16.6822 97.451 17.0755 96.273 17.0755C95.0883 17.0755 94.1008 16.6822 93.3037 15.8941C92.5083 15.1076 92.1123 14.1424 92.1123 13C92.1123 11.8576 92.5083 10.8924 93.3037 10.1059C94.1008 9.31775 95.0883 8.9245 96.273 8.9245C97.4442 8.9245 98.4318 9.31775 99.2288 10.1124C100.031 10.9054 100.427 11.8641 100.427 13C100.427 14.1424 100.031 15.1076 99.2356 15.8941ZM94.0739 15.2409C94.6738 15.8242 95.4035 16.1167 96.273 16.1167C97.1358 16.1167 97.8723 15.8242 98.4655 15.2409C99.0637 14.6575 99.367 13.9084 99.367 13C99.367 12.0916 99.0637 11.3425 98.4655 10.7591C97.8723 10.1757 97.1358 9.88325 96.273 9.88325C95.4035 9.88325 94.6738 10.1757 94.0739 10.7591C93.4756 11.3425 93.1723 12.0916 93.1723 13C93.1723 13.9084 93.4756 14.6575 94.0739 15.2409Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.888 16.8968V9.10327H103.152L107.082 15.1645H107.127L107.082 13.6663V9.10327H108.121V16.8968H107.036L102.921 10.5365H102.875L102.921 12.0413V16.8968H101.888Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8559 28.2783C88.6895 28.2783 86.1027 30.602 86.1027 33.8082C86.1027 36.9883 88.6895 39.3364 91.8559 39.3364C95.0291 39.3364 97.6159 36.9883 97.6159 33.8082C97.6159 30.602 95.0291 28.2783 91.8559 28.2783ZM91.8559 37.1589C90.1185 37.1589 88.6238 35.776 88.6238 33.8082C88.6238 31.8143 90.1185 30.4558 91.8559 30.4558C93.5934 30.4558 95.0949 31.8143 95.0949 33.8082C95.0949 35.776 93.5934 37.1589 91.8559 37.1589ZM79.303 28.2783C76.1298 28.2783 73.5498 30.602 73.5498 33.8082C73.5498 36.9883 76.1298 39.3364 79.303 39.3364C82.4745 39.3364 85.0562 36.9883 85.0562 33.8082C85.0562 30.602 82.4745 28.2783 79.303 28.2783ZM79.303 37.1589C77.5639 37.1589 76.0641 35.776 76.0641 33.8082C76.0641 31.8143 77.5639 30.4558 79.303 30.4558C81.0404 30.4558 82.5352 31.8143 82.5352 33.8082C82.5352 35.776 81.0404 37.1589 79.303 37.1589ZM64.3655 29.9732V32.3229H70.1845C70.0143 33.6359 69.5593 34.6012 68.8616 35.2739C68.0123 36.0864 66.6894 36.9883 64.3655 36.9883C60.7845 36.9883 57.9804 34.2014 57.9804 30.7483C57.9804 27.2952 60.7845 24.5083 64.3655 24.5083C66.3018 24.5083 67.7106 25.2379 68.7504 26.1837L70.4676 24.5278C69.0133 23.1888 67.0787 22.1602 64.3655 22.1602C59.4549 22.1602 55.3279 26.013 55.3279 30.7483C55.3279 35.4835 59.4549 39.3364 64.3655 39.3364C67.0197 39.3364 69.0133 38.4979 70.5805 36.9249C72.1865 35.3763 72.687 33.1988 72.687 31.4405C72.687 30.8945 72.6398 30.3924 72.5555 29.9732H64.3655ZM125.447 31.7948C124.973 30.5582 123.512 28.2783 120.536 28.2783C117.587 28.2783 115.132 30.5192 115.132 33.8082C115.132 36.9054 117.562 39.3364 120.819 39.3364C123.453 39.3364 124.973 37.7878 125.598 36.8859L123.644 35.6298C122.991 36.5495 122.103 37.1589 120.819 37.1589C119.544 37.1589 118.628 36.595 118.042 35.4835L125.711 32.4237L125.447 31.7948ZM117.627 33.6359C117.562 31.5039 119.345 30.4119 120.622 30.4119C121.623 30.4119 122.472 30.8945 122.755 31.5852L117.627 33.6359ZM111.394 39H113.915V22.75H111.394V39ZM107.265 29.51H107.181C106.615 28.8633 105.535 28.2783 104.166 28.2783C101.295 28.2783 98.6692 30.7093 98.6692 33.826C98.6692 36.9249 101.295 39.3364 104.166 39.3364C105.535 39.3364 106.615 38.7465 107.181 38.0803H107.265V38.8733C107.265 40.9874 106.094 42.1233 104.205 42.1233C102.665 42.1233 101.709 41.0508 101.315 40.1489L99.1225 41.0313C99.7544 42.497 101.428 44.3008 104.205 44.3008C107.161 44.3008 109.655 42.6238 109.655 38.5434V28.6147H107.265V29.51ZM104.382 37.1589C102.644 37.1589 101.19 35.7565 101.19 33.826C101.19 31.8777 102.644 30.4558 104.382 30.4558C106.094 30.4558 107.444 31.8777 107.444 33.826C107.444 35.7565 106.094 37.1589 104.382 37.1589ZM137.25 22.75H131.22V39H133.734V32.8429H137.25C140.042 32.8429 142.781 30.8945 142.781 27.7957C142.781 24.6984 140.035 22.75 137.25 22.75ZM137.315 30.5825H133.734V25.0104H137.315C139.193 25.0104 140.265 26.5135 140.265 27.7957C140.265 29.0534 139.193 30.5825 137.315 30.5825ZM152.858 28.2474C151.041 28.2474 149.152 29.0209 148.375 30.7353L150.607 31.6372C151.087 30.7353 151.97 30.4428 152.903 30.4428C154.208 30.4428 155.531 31.1984 155.551 32.5325V32.7032C155.096 32.4497 154.122 32.0743 152.924 32.0743C150.521 32.0743 148.072 33.3499 148.072 35.7305C148.072 37.908 150.04 39.3104 152.253 39.3104C153.945 39.3104 154.878 38.5743 155.465 37.7179H155.551V38.974H157.979V32.7405C157.979 29.8594 155.748 28.2474 152.858 28.2474ZM152.555 37.1524C151.732 37.1524 150.586 36.7592 150.586 35.776C150.586 34.5183 152.015 34.0357 153.252 34.0357C154.359 34.0357 154.878 34.2713 155.551 34.5817C155.354 36.0864 154.011 37.1524 152.555 37.1524ZM166.826 28.6033L163.936 35.6477H163.85L160.863 28.6033H158.151L162.64 38.4475L160.079 43.9254H162.706L169.624 28.6033H166.826ZM144.162 39H146.683V22.75H144.162V39Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_2755",
    x1: 29.3891,
    y1: 40.6773,
    x2: 7.58642,
    y2: 18.0671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_301_2755",
    x1: 45.6138,
    y1: 25.9982,
    x2: 12.9927,
    y2: 25.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_301_2755",
    x1: 33.4704,
    y1: 23.015,
    x2: 3.90419,
    y2: -7.64623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_301_2755",
    x1: 9.83779,
    y1: 51.7709,
    x2: 23.0404,
    y2: 38.0794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_2755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145.6,
    height: 41.6,
    fill: "white",
    transform: "matrix(1.25 0 0 -1.25 0 52)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreButton);
export default __webpack_public_path__ + "static/media/playstore-button.3a6682e91862523157d4d60ee2926123.svg";
export { ForwardRef as ReactComponent };